import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Chart from "chart.js";
import moment from "moment-timezone";
import numeral from "numeral";
import _ from "lodash";
import { Button } from "reactstrap";

import classes from "./Graph.module.scss";
import * as actionTypes from "../../../../store/actions/actionTypes";

// helper functions to handle special cases (THIS SHOULD NOT BE USED OFTEN)
const CHECK_FOR_CAMPAIGN = [54];
function handleCampaign(id, date, impressions) {
  if (id === 54) {
    // date = moment(date).month();
    impressions *= 0.82;
    if(moment(date).isBetween("2020-03-11", "2020-04-15", null, "[]")){
      impressions *= 0.5;
    } else if(moment(date).isBetween("2020-04-16", "2020-05-11", null, "[]")){
      impressions *= 0.63;
    } else if(moment(date).isBetween("2020-05-12", "2020-06-07", null, "[]")){
      impressions *= 0.805;
    }
  }
  return Math.round(impressions);
}


// Exports JS array to CSV file (ty stack overflow)
function exportToCsv(filename, rows) {
    var processRow = function (row) {
        var finalVal = '';
        for (var j = 0; j < row.length; j++) {
            var innerValue = row[j] === null ? '' : row[j].toString();
            if (row[j] instanceof Date) {
                innerValue = row[j].toLocaleString();
            };
            var result = innerValue.replace(/"/g, '""');
            if (result.search(/("|,|\n)/g) >= 0)
                result = '"' + result + '"';
            if (j > 0)
                finalVal += ',';
            finalVal += result;
        }
        return finalVal + '\n';
    };

    var csvFile = '';
    for (var i = 0; i < rows.length; i++) {
        csvFile += processRow(rows[i]);
    }

    var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8;' });
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, filename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

class Graph extends Component {

  impressionsRef = React.createRef();
  milesRef = React.createRef();
  impressionsGraph = null;
  milesGraph = null;

  removeData = (chart) => {
    chart.data.labels = [];
    chart.data.datasets = [];
    chart.update();
  };

  // temp to just put something in impressions
  estimateHourImpressions(mileage, date, flag) {
    if (mileage > 0) {
      let impressions = 150 + 270 * mileage;
      impressions = flag ? handleCampaign(parseInt(this.props.selected), date, impressions) : impressions;
      return Math.round(impressions);
    } else {
      return 60;
    }
  }

  generateAnalyticsCSV = async () => {
    let impressionsData = this.impressionsGraph.data.datasets[0].data;
    let datesData = this.impressionsGraph.data.labels
    let milesData = this.milesGraph.data.datasets[0].data

    let csv_array = [["Date", "Daily Impressions", "Cumulative Impressions", "Daily Miles", "Cumulative Miles"]];

    let cumulative_miles = 0;
    for (let i = 0; i < datesData.length; i++){
      cumulative_miles = cumulative_miles + milesData[i];

      csv_array.push([
        datesData[i],
        impressionsData[i] - (i > 0 ? impressionsData[i-1] : 0),
        impressionsData[i],
        milesData[i],
        cumulative_miles
      ]);
    }
    let cleaned_name = (this.props.campaigns[this.props.selected].name.replace(/[^A-Z0-9]+/ig, "_")).toLowerCase()+'.csv';
    exportToCsv(cleaned_name, csv_array);

  }
  updateData = (impressionsGraph, milesGraph) => {
    if (this.props.campaigns[this.props.selected]) {
      let vehicleCount = 0,
        totalMilesDriven = 0;
      // clear impressionsGraph
      impressionsGraph.data.labels = [];
      impressionsGraph.data.datasets[0].data = [];
      milesGraph.data.labels = [];
      milesGraph.data.datasets[0].data = [];
      // get vehicles
      let vehicles = this.props.campaigns[this.props.selected].vehicles;
      vehicleCount = Object.keys(vehicles).length;
      let dailyStats = {};
      let flag_campaign = CHECK_FOR_CAMPAIGN.includes(parseInt(this.props.selected));
      // loop through vehicles and paths in selected campaign
      for (const [key, vehicle] of Object.entries(vehicles)) {
        // if anaytlics key exsits, it's a regular truck that has list of mileage/impressions
        if (vehicle.analytics) {
          // loop through analytics variable
          for (let row of vehicle.analytics) {
            console.log(row);
            if (row?.campaignId == this.props.selected) {
              let date = moment(row.date).utc().format("M/DD/YYYY");
              // if date key exists, add to existing sum
              if (date in dailyStats) {
                dailyStats[date].mileage += row.distance;
                dailyStats[date].impressions += row.impressions;
              } else {
                // otherwise create new key/value
                dailyStats[date] = {
                  mileage: row.distance,
                  impressions: row.impressions
                };
              }
            }
          }
        } else {
          // otherwise it's a placeholder truck that needs to loop through each path to calculate mileage/impressions
          for (let path of vehicle?.paths) {
            // sort dates using the start date and sum miles for each day
            let date = moment(path.end).utc().format("M/DD/YYYY");
            // add to total miles driven
            // linxup sometimes has buggy data, anything over 100 is unrealistic in an hour
            if (path.distance > 1000) {
              path.distance = 20;
            }
            // use impression count from db. if it doesn't exist, estimate the impression count
            let impressions = path.impressions ? path.impressions : this.estimateHourImpressions(path.distance, date, flag_campaign);
            // if date key exists, add to existing sum
            if (date in dailyStats) {
              dailyStats[date].mileage += path.distance;
              dailyStats[date].impressions += impressions;
            } else {
              // otherwise create new key/value
              dailyStats[date] = {
                mileage: path.distance,
                impressions: impressions
              };
            }
          }
        }
      }
      let totalImpressions = 0;
      let orderedDailyStats = {};
      // sort data by date
      Object.keys(dailyStats)
        .sort((a, b) => {
          a = moment(a);
          b = moment(b);
          return a.isBefore(b) ? -1 : a.isAfter(b) ? 1 : 0;
        })
        .forEach((date) => {
          orderedDailyStats[date] = dailyStats[date];
        });
      for (const [date, dailyStat] of Object.entries(orderedDailyStats)) {
        totalMilesDriven += Math.round(dailyStat.mileage);
        totalImpressions += dailyStat.impressions;
        impressionsGraph.data.labels.push(date);
        milesGraph.data.labels.push(date);
        impressionsGraph.data.datasets[0].data.push(totalImpressions);
        milesGraph.data.datasets[0].data.push(dailyStat.mileage);
      }
      impressionsGraph.update();
      milesGraph.update();
      this.props.updateAnalytics(vehicleCount, totalMilesDriven, totalImpressions);
    }
  };

  componentDidUpdate() {
    this.updateData(this.impressionsGraph, this.milesGraph);
  }
  componentDidMount() {
    // initialize impressions graph
    const impressionsContext = this.impressionsRef.current.getContext("2d");
    let data = {
      label: [],
      datasets: [
        {
          label: "Total Impressions",
          data: [],
          backgroundColor: "rgba(56, 165, 242, 0.2)",
          borderColor: "rgba(56, 165, 242, 1)",
          borderWidth: 2
        }
      ]
    };

    let options = {
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      tooltips: {
        mode: "x-axis",
        callbacks: {
          label: (tooltipItem, data) => {
            let value = data.datasets[0].data[tooltipItem.index];
            return numeral(value).format("0,0");
          }
        }
      },
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              userCallback: (value) => {
                return numeral(value).format("0,0");
              }
            }
          }
        ]
      }
    };
    this.impressionsGraph = new Chart(impressionsContext, {
      type: "line",
      data: data,
      options: options
    });
    // initialize miles graph
    const milesContext = this.milesRef.current.getContext("2d");
    data = {
      labels: [],
      datasets: [
        {
          label: "Miles Driven (Daily)",
          data: [],
          backgroundColor: "rgba(255, 99, 132, 1)",
          maxBarThickness: 100
        }
      ]
    };
    this.milesGraph = new Chart(milesContext, {
      type: "bar",
      data: data,
      options: options
    });
    if (!_.isEmpty(this.props.campaigns)) {
      this.updateData(this.impressionsGraph, this.milesGraph);
    }
  }

  render() {
    return (
      <Fragment>
        <div className={classes.wrapper}>
          <canvas ref={this.impressionsRef} />
        </div>
        <div className={classes.wrapper}>
          <canvas ref={this.milesRef} />
        </div>
        {this.props.campaigns[this.props.selected].csv_report_enabled &&(
        <div className={classes.reportsWrapper}>
        <h5>Reports</h5>
        <div className={classes.buttonWrapper}>
        <p>Campaign analytics report for <b>{this.props.campaigns[this.props.selected].name}</b>
        <Button onClick={this.generateAnalyticsCSV} className={classes.csvButton}>
          Download
        </Button>
        </p>
        </div>
        </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    campaigns: state.clientDashboard.campaigns,
    selected: state.clientDashboard.selected
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAnalytics: (vehicleCount, miles, impressions) => {
      dispatch({
        type: actionTypes.UPDATE_ANALYTICS,
        vehicleCount: vehicleCount,
        miles: miles,
        impressions: impressions
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Graph);
